import { gql } from '@apollo/client';

const GET_ALGOLIA_CONFIGS = gql`
  query {
    getAlgoliaIndex {
      workoutIndex
      releaseIndex
    }
    getAlgoliaConfig {
      index
      key
    }
  }
`;

export const GET_ALGOLIA_CONFIG_V2 = gql`
  query {
    getAlgoliaConfigV2 {
      index
      key
    }
  }
`;

export default GET_ALGOLIA_CONFIGS;
